import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ConfirmModal from 'src/components/confirm-modal';
import './style.scss';

function ConfirmReactivateModal({ visible, onCancel, onConfirm, collaborator, loading }) {
  const { t } = useTranslation();
  
  const collaboratorLogin = collaborator?.collaborator_deallocation?.login || '';
  
  return (
    <ConfirmModal
      title={t('reactivateProfile')}
      visible={visible}
      onCancel={onCancel}
      onConfirm={onConfirm}
      okText={t('confirm')}
      cancelText={t('cancel')}
      confirmLoading={loading}
      okButtonProps={{ 
        className: 'cit-btn primary-type'
      }}
      className="confirm-reactivate-modal"
    >
      <div className="confirm-reactivate-modal__content">
        <p className="confirm-reactivate-modal__question">
          {t('reactivateModal.question')} <strong className="login-highlight">{collaboratorLogin}</strong>?
        </p>
        <p className="confirm-reactivate-modal__reminder">
          {t('reactivateModal.reminder')}
        </p>
      </div>
    </ConfirmModal>
  );
}

ConfirmReactivateModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  collaborator: PropTypes.object,
  loading: PropTypes.bool
};

export default ConfirmReactivateModal;